<template>
  <div class="saved-notifications">
    <v-card v-for="(notification, index) in savedNotifications" :key="index" class="saved-notifications-card mb-2">
      <v-card-text>
        <div>
          <span><strong>Sender:</strong> {{ notification.sender }}</span><br>
          <span><strong>Subject Keyword:</strong> {{ notification.subjectKeyword }}</span><br>
          <v-icon :color="notification.notified ? 'green' : 'red'">mdi-email</v-icon>
        </div>
        <v-btn small color="primary" @click="$emit('edit', index)">Edit</v-btn>
        <v-btn small color="error" @click="$emit('delete', index)">Delete</v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'SavedNotifications',
  props: {
    savedNotifications: {
      type: Array,
      required: true
    }
  }
};
</script>

<style scoped>

.saved-notifications-card {

  margin: 0 auto;
  padding: 20px 20px 20px 20px;
  background-color: rgba(71, 74, 117, 0.416);
  border-radius: 15px;
}
</style>